import { render } from "./details.vue?vue&type=template&id=77794be4&scoped=true"
const script = {}

import "./details.vue?vue&type=style&index=0&id=77794be4&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77794be4"]])

export default __exports__